import React from "react";
import Layout from "../components/Common/Layout";
import PendingRegistration from "../components/PendingRegistration/PendingRegistration";

const PendingRegistrationPage = () => {
  return (
    <Layout>
      <PendingRegistration />
    </Layout>
  );
};

export default PendingRegistrationPage; 